<i18n src="@/common/i18n/i18n-locales.json"></i18n>

<template>
  <f7-actions>
    <f7-actions-group>
      <f7-actions-label>{{ currentItem.title }}</f7-actions-label>
    </f7-actions-group>
    <f7-actions-group>
      <f7-actions-button @click="$f7.views.main.router.navigate(`/stores/${storeIdProp}/menu-drafts/${currentDraft.variation}/edit-item`)">
        <font-awesome-icon icon="edit" style="margin-right: 5px;" />
        編輯餐點
      </f7-actions-button>
      <f7-actions-button @click="$f7.views.main.router.navigate(`/stores/${storeIdProp}/menu-drafts/${currentDraft.variation}/edit-item-question`)">
        <font-awesome-icon icon="edit" style="margin-right: 5px;" />
        編輯餐點選項
      </f7-actions-button>
      <f7-actions-button @click="$f7.views.main.router.navigate(`/stores/${storeIdProp}/menu-drafts/${currentDraft.variation}/duplicate-actions`)">
        <font-awesome-icon :icon="['far', 'copy']" style="margin-right: 5px;" />
        複製餐點
      </f7-actions-button>
      <f7-actions-button color="red" @click="onDeleteItem({ groupId, itemId: itemIdProp, index: currentElementPath[2].index })">
        <font-awesome-icon icon="trash" style="margin-right: 10px;" />
        刪除餐點
      </f7-actions-button>
    </f7-actions-group>
  </f7-actions>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'ItemActionSheet',
  props: {
    storeIdProp: String,
    menuDraftVariationProp: String,
    itemIdProp: String
  },
  computed: {
    ...mapState('menuDraftModule', ['currentElementPath', 'currentDraft']),
    categoryId () { return this.currentElementPath[0].id },
    groupId () { return this.currentElementPath[1].id },
    currentItem () { return this.currentDraft.items[this.itemIdProp] }
  },
  methods: {
    ...mapActions('menuDraftModule', ['setCurrentElementPath', 'deleteItem']),
    onDeleteItem ({ groupId, itemId, index }) {
      this.$f7.dialog.confirm(`確定要刪除 ${this.currentItem.title} ?`, '刪除餐點', () => {
        this.deleteItem({ groupId, itemId, index })
      })
    }
  }
}
</script>
